// Rücksprung aus der vollständigen Kontaktanlage in die Alte Kundenakte
// (Plan 01.10.2026, B2): Das Zuweisen-Popup bietet „weitere Infos" an und
// schickt den Nutzer in die Anlage-Seite. Die trägt `?zurueck=` (wohin danach)
// und `?kundenakteOrdner=` (welcher Ordner dem neuen Kontakt zugewiesen wird).
// Nach dem Speichern weist die Seite zu und kehrt zurück — der Nutzer landet
// wieder dort, wo er angefangen hat, mit zugewiesener Akte.

import { apiUrl } from "./api";

type ParamLeser = { get(name: string): string | null };

export type Ruecksprung = { zurueck: string | null; ordnerId: number | null };

/** Nur interne Pfade — eine fremde Adresse im Parameter wird nicht angesprungen. */
const istInternerPfad = (p: string): boolean => p.startsWith("/") && !p.startsWith("//");

export const ruecksprungAusParams = (p: ParamLeser): Ruecksprung => {
  const zurueck = (p.get("zurueck") ?? "").trim();
  const ordner = parseInt((p.get("kundenakteOrdner") ?? "").trim(), 10);
  return {
    zurueck: zurueck && istInternerPfad(zurueck) ? zurueck : null,
    ordnerId: Number.isInteger(ordner) && ordner > 0 ? ordner : null,
  };
};

/** Die Parameter an einen Anlage-Pfad hängen (`?name=…` ist schon dran). */
export const mitRuecksprung = (anlagePfad: string, zurueck: string, ordnerId: number): string =>
  `${anlagePfad}${anlagePfad.includes("?") ? "&" : "?"}${new URLSearchParams({ zurueck, kundenakteOrdner: String(ordnerId) }).toString()}`;

/**
 * Nach der Anlage den Ordner zuweisen. Scheitert die Zuweisung, bleibt der
 * Kontakt angelegt — der Aufrufer sagt das und führt trotzdem zurück, denn in
 * der Übersicht lässt sich die Zuweisung nachholen.
 */
export async function nachAnlageZuweisen(ordnerId: number, contactId: number): Promise<boolean> {
  try {
    const res = await fetch(apiUrl(`kundenakten-folders/${ordnerId}/assign`), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ contactIds: [contactId] }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
